import {
  Navigate,
  Outlet,
  useOutletContext,
  useParams,
} from "react-router-dom";
import type { RootOutletContext } from "../shared/outletContextsTypes";
import { TenantContext } from "../tenancy/TenantContext";
import { getOrgSlugs } from "../tenancy/getOrgSlugs";

export function BaseTenantLayout() {
  const rootOutletContext = useOutletContext<RootOutletContext>();

  return (
    <TenantContext.Provider
      value={{
        type: "base",
        orgSlug: null,
        basePath: "",
      }}
    >
      <Outlet context={rootOutletContext} />
    </TenantContext.Provider>
  );
}

export function OrgTenantLayout() {
  const rootOutletContext = useOutletContext<RootOutletContext>();
  const { orgSlug } = useParams();

  if (!orgSlug) {
    return <Navigate to="/" replace />;
  }

  const slugs = getOrgSlugs();
  if (!slugs.includes(orgSlug)) {
    return <Navigate to="/" replace />;
  }

  return (
    <TenantContext.Provider
      value={{
        type: "org",
        orgSlug,
        basePath: `/${orgSlug}`,
      }}
    >
      <Outlet context={rootOutletContext} />
    </TenantContext.Provider>
  );
}
